
export const name = "forecasting-ui";
export const version = "dev";
